import { Menu } from "@headlessui/react";
import React from "react";
import { joinClasses } from "../../utils/joinClasses";
export const DropdownItems = ({ className, ...props }) => (React.createElement(Menu.Items, { className: joinClasses(["nxm-dropdown-items", className]), ...props }));
